import React from 'react'

import close from './../../../UI/general/close_white.svg'

interface Props {
  data: any
}

interface State {
  textToshow: string
  showTextoLegal: boolean
}

class SecondaryLegalText extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      textToshow: '',
      showTextoLegal: false
    }
  }

  componentDidMount(): void {
    console.log(this.props.data)
    if(this.props.data.texto_legal_secundario){
      this.setState({
        textToshow: this.props.data.texto_legal_secundario,
        showTextoLegal: true
      })
    }
  }

  render(): React.ReactNode {
      return(
        <div 
          className={this.state.showTextoLegal ? 
          'secondary-legal-text-container fade-in':
          'secondary-legal-text-container fade-out'
          } 
          style={{
            backgroundColor:this.props.data.colors.main_buttons + "E6",
            color: this.props.data.colors.secondary_text
          }}
        >
          <div className='secondary-legal-text-title'>TEN EN CUENTA QUE</div>
          <div className='secondary-legal-text'>
            {this.state.textToshow}
          </div>
          <div className='close-legal-text' onClick={() => {this.setState({showTextoLegal: false})}} style={{
            backgroundColor:this.props.data.colors.main_buttons + "E6",
            color: this.props.data.colors.secondary_text
          }}>
            <img src={close} alt=''/> 
          </div>
        </div>
      )
  }
}

export default SecondaryLegalText